import { Card, SmallText } from 'hui';
import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { EventActions, EventCategories } from '../../../constants/Analytics';
import { getThumborURL } from '../../../utils/thumbor';

const ImageCover = styled.div`
  width: 100%;
  height: 120px;
  background-size: cover;
  background-image: url("${props => getThumborURL(props.heroImage)}")
`;

const MediaCard = styled(Card)`
  height: 200px;
  overflow: hidden;
  a {
    text-decoration: none;
  }
`;

const ParagraphSection = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
  text-align: center;
  margin: 0;
`;

const LatestArticleMediaBlock = ({ name, hero, articleKey }) => (
  <div>
    <MediaCard snow p={0} mt={1}>
      <Link
        to={`/article/${articleKey}`}
        data-ga-category={EventCategories.ARTICLES}
        data-ga-action={EventActions.LATEST_ARTICLES_CLICK_IMAGE}
        data-ga-label={`[/article/${articleKey}]`}
      >
        <ImageCover heroImage={hero} />
      </Link>
      <ParagraphSection>
        <Link
          to={`/article/${articleKey}`}
          data-ga-category={EventCategories.ARTICLES}
          data-ga-action={EventActions.LATEST_ARTICLES_CLICK_LINK}
          data-ga-label={`[/article/${articleKey}]`}
        >
          <SmallText color="primary">{name}</SmallText>
        </Link>
      </ParagraphSection>
    </MediaCard>
  </div>
);

LatestArticleMediaBlock.propTypes = {
  articleKey: PropTypes.string,
  name: PropTypes.string,
  hero: PropTypes.string
};

export default LatestArticleMediaBlock;
